import { State, Action, StateContext, Actions, ofActionSuccessful } from '@ngxs/store';
import { StoreSourceInfos, GetIssuers, GetProducts, StoreResource, StoreInfoUser, GetThirdApps } from './app.actions';
import { Injectable } from '@angular/core';
import { Dispatcher } from './base/dispatcher';
import { LocalStorageService } from 'ngx-webstorage';
import { EventManager, UserService } from '../core';
import { AppsService } from '../shared/services/apps.service';
import { QueryParams } from '../shared/model/query.params.model';
declare let $: any;
export interface AppStateModel {
    userProfile: any;
    sourceInfos: any;
    resources: any;
    issuers: any;
    products: any;
    thirdApps: any;
    activeProducts: any;
}

export function initAppState(): AppStateModel {
    return {
        issuers: [],
        products: [],
        thirdApps: []
    } as AppStateModel;
}

@State<AppStateModel>({
    name: 'App',
    defaults: initAppState()
})
@Injectable({ providedIn: 'root' })
export class AppState {

    constructor(
        private actions$: Actions,
        private dispatcher: Dispatcher,
        private appsService: AppsService,
        private localStorage$: LocalStorageService,
        public eventManger: EventManager,
    ) { }

    @Action(StoreInfoUser)
    StoreInfoUser(ctx: StateContext<AppStateModel>, action: StoreInfoUser) {
        const userProfile = action.payload;
        localStorage.setItem('accountType', userProfile.adminGroup.code);
        ctx.patchState({
            userProfile
        });
        this.GetProducts(ctx, action);
    }
    @Action(StoreSourceInfos)
    StoreSourceInfos(ctx: StateContext<AppStateModel>, action: StoreSourceInfos) {
        const sourceInfos = action.payload;
        ctx.patchState({
            sourceInfos
        });
    }
    @Action(StoreResource)
    StoreResource(ctx: StateContext<AppStateModel>, action: StoreResource) {
        return this.appsService.getResources()
        .subscribe((res: any) => {
            const resources = res.body.data || {};
            (resources.phonePostalCodes || []).forEach((item, index) => {
                item.id = index;
                item.name = item.countryCode + ' (+' + item.callingCode + ')';
            });
            ctx.patchState({
                resources
            });
        });
    }
    @Action(GetProducts)
    GetProducts(ctx: StateContext<AppStateModel>, action: GetProducts) {
        let body = {
            page: 1,
            pageSize: 1000,
            statusId: [6, 7, 9],
            typeCodes: ['TRADING_FUND', 'NEW_FUND']
        };
        return this.appsService
        .getProductsMini(body)
        .subscribe(
          (res: any) => {
            const products = (res.data.list || []).map((item) => {
                item.showName = `${item.code} - ${item.name}`;
                item.ownerId = (item.owner || {}).id || (item.owner || {}).userId;
                return item;
            });
            ctx.patchState({
                products
            });
          },
        );
    }
    @Action(GetThirdApps)
    GetThirdApps(ctx: StateContext<AppStateModel>, action: GetThirdApps) {
        const queryParams = new QueryParams();
        queryParams.size = 1000;
        this.appsService.getThirdAppList(queryParams)
          .subscribe(
            (res: any) => {
              const thirdApps = res.body.data.list || [];
              ctx.patchState({
                thirdApps
            });
            },
          );
    }

    loadAgents() {
       
      }
}
